import { ImageViewerComponent, PropertiesEditorFormComponent } from '@barthauer/abc/common-editors';
import { CompareHelper, ConvertHelper, StringHelper } from '@barthauer/abc/core';
import { ObjectTypeInfoViewModel } from '@barthauer/abc/core/data';
import {
  AbcDateBoxComponent,
  AbcEditorComponent,
  AbcNumberBoxComponent,
  AbcTextBoxComponent,
} from '@barthauer/abc/ui-components';
import { ValueWrapper } from '../../../helpers/valueWrapper';
import { SpecialType } from '../../models/layout.model';
import { StandardComponent } from '../../shared/type';
import { DataFormService } from '../data-form.service';
import { DataFormSettings } from './settings.model';
import { UiCreatorBase } from './ui/ui-creator-base';

export class Binding extends UiCreatorBase {
  constructor(
    private service: DataFormService,
    private settings: DataFormSettings,
  ) {
    super(service, settings);
  }

  public async bind(): Promise<void> {
    if (!CompareHelper.isEmptyObject(this.settings.selectedObject)) {
      this.settings.objectKey.id = this.settings.selectedObject?.Object?.Id;
      this.settings.objectKey.objectType =
        this.settings.selectedObject?.Object?.ObjectType ??
        this.service.abcArena.context.defaultObjectType ??
        this.settings.layoutViewModel?.objectType;

      if (this.settings.objectKey.objectType) {
        // this.settings.isPropertiesDisabled = false;
        // this.settings.isCommentsDisabled = false;
        // this.settings.isDocumentsDisabled = false;

        for (const e of Array.from(this.settings.layoutViewModel.columnsObjectMap)) {
          const columnObjects = e[1];

          for (const column of columnObjects) {
            // if (column?.LayoutColumn?.SpecialType === SpecialType.PropertiesEditor) {
            //   this.settings.isPropertiesDisabled = true;
            // }
            // if (column?.LayoutColumn?.SpecialType === SpecialType.CommentsEditor) {
            //   this.settings.isCommentsDisabled = true;
            // }
            // if (column?.LayoutColumn?.SpecialType === SpecialType.DocumentsEditor) {
            //   this.settings.isDocumentsDisabled = true;
            // }

            let initialDisplayText: string = undefined;
            let initialValue = this.settings.selectedObject?.data[column.Key];

            if (column.LayoutColumn?.IsRef && !CompareHelper.isNullorEmpty(initialValue)) {
              initialDisplayText = this.service.prepareInitialDropDownText(
                initialValue,
                this.settings.selectedObject?.data['DisplayText:' + column.Key],
              );
            }

            column.ValueWrapper = new ValueWrapper(
              column.Key,
              column.LayoutColumn?.OPath,
              initialValue,
              this.settings.objectKey,
              this.service.persistence,
              initialDisplayText,
            );
            this.settings.listOfValueWrappers[column.Key] = column.ValueWrapper;
            // if (typeof this.settings.selectedObject.data[column.Key] === 'number') {
            //   const decimalDigits: number = <number>(<AbcNumberBoxComponent>column.Control)?.value;
            //   if (decimalDigits)
            //     this.settings.selectedObject.data[column.Key] = (<number>(
            //       this.settings.selectedObject.data[column.Key]
            //     )).toFixed(decimalDigits);
            // }
            if (column?.Control) {
              if (column.LayoutColumn?.SpecialType === SpecialType.PropertiesEditor) {
                (<PropertiesEditorFormComponent>column.Control).parentInfo = {
                  id: this.settings.selectedObject?.Object?.Id,
                  objectType: this.settings.mainObjectTypeViewModel?.name ?? this.settings.layoutViewModel.objectType,
                };
                // column.Control.ngOnDestroy();
              } else if (column.LayoutColumn?.SpecialType === SpecialType.ObjectTypeDesignation) {
                (<AbcTextBoxComponent>column.Control).value = await this.service.arena.getObjectTypeTextAsync(
                  this.settings.selectedObject?.data[column.Key],
                );
              } else if (
                column.LayoutColumn?.SpecialType === SpecialType.LinkLabel ||
                column.LayoutColumn?.SpecialType === SpecialType.LinkLabelEmail ||
                column.LayoutColumn?.SpecialType === SpecialType.LinkLabelUrl
              ) {
                this.prepareLinkLabel(column, this.settings.selectedObject?.data);
              } else if (column.LayoutColumn?.SpecialType === SpecialType.DocumentsEditor) {
                this.loadLayoutImages();
                (<ImageViewerComponent>column.Control).source = this.settings.layoutViewModel.images;
              } else if (column.LayoutColumn?.SpecialType === SpecialType.Comment) {
                if (column.LayoutColumn?.isEditableComment) {
                  (<AbcEditorComponent>column.Control).value = <string>(
                    this.settings.selectedObject?.data['__' + column.Key]
                  );
                } else {
                  if (column.LayoutColumn?.OPath?.endsWith('__Json')) {
                    (<AbcEditorComponent>column.Control).readOnly = true;
                  }
                  let v = this.settings.selectedObject.data[column.Key];
                  if (v && typeof v === 'object') {
                    v = JSON.stringify(v);
                  }
                  (<AbcEditorComponent>column.Control).value = <string>v;
                }
              } else if (column?.Control instanceof AbcDateBoxComponent && column.Control.type == 'time') {
                column.Control.value = this.settings.selectedObject?.data[column.Key];
              } else if (
                column?.Control instanceof AbcNumberBoxComponent &&
                typeof this.settings.selectedObject?.data[column.Key] === 'string'
              ) {
                const text = this.settings.selectedObject?.data[column.Key]?.replace(',', '.');
                if (text) {
                  try {
                    column.Control.value = parseFloat(text);
                  } catch {
                    column.Control.value = text;
                  }
                } else {
                  column.Control.value = text;
                }
              } else if (!column.LayoutColumn.IsRef) {
                (<StandardComponent>column.Control).value = this.settings.selectedObject?.data[column.Key];
              }
            }
            this.settings.abcComponentInstances[column.Key] = column.Control;
          }
        }
      }
    }
    this.service.persistence.clearPendingObjects(this.service.arena.PERSISTENCE_CATEGORY);
    this.settings.objectKey.listOfValueWrappers = this.settings.listOfValueWrappers;
    this.settings.objectKey.abcComponentContainer = this.settings.abcComponentInstances;
  }

  public clear(displayTextValues?: Map<string, string>): Promise<void> {
    return new Promise((resolve) => {
      this.settings.linkLabelsMap.forEach((link) => {
        const node = link.getElementsByClassName('dx-texteditor-input')[0] as HTMLAnchorElement;
        if (node) {
          node.innerText = '';
          node.href = '';
        }
      });
      this.clearDataFormSettings();
      if (this.settings.gridOnFormInstances.length > 0) {
        this.settings.gridOnFormInstances.forEach((grid) => grid.instance?.refresh());
      }
      resolve({});
    }).then(() => {
      this.service.persistence.clearPendingObjects(this.service.arena.PERSISTENCE_CATEGORY);
      this.service.persistence.addObjectForInsert(this.settings.objectKey);
      this.settings.setReferencingColumn(this.settings.objectKey, displayTextValues);
      this.settings.setParentReferencingColumn(this.settings.objectKey, displayTextValues);
    });
  }

  private clearDataFormSettings() {
    this.settings.objectKey.id = null;
    this.settings.objectKey.objectType =
      this.service.abcArena.context.defaultObjectType ?? this.settings.layoutViewModel?.objectType;
    this.settings.layoutViewModel?.columnsObjectMap.forEach((columnObject, key) => {
      columnObject.forEach((column) => {
        column.ValueWrapper = new ValueWrapper(
          column.Key,
          column.LayoutColumn?.OPath,
          null,
          this.settings.objectKey,
          this.service.persistence,
        );
        this.settings.listOfValueWrappers[column.Key] = column.ValueWrapper;
        if (column?.Control) {
          if (column.LayoutColumn?.SpecialType === SpecialType.PropertiesEditor) {
            (<PropertiesEditorFormComponent>column.Control).parentInfo = {
              id: null,
              objectType: this.settings.mainObjectTypeViewModel?.name ?? this.settings.layoutViewModel.objectType,
            };
            (<PropertiesEditorFormComponent>column.Control).ngOnDestroy();
          }
          if (column?.Control instanceof AbcDateBoxComponent) {
            (<StandardComponent>column.Control).value = null;
          } else if (column.LayoutColumn.IsRef) {
            (<StandardComponent>column.Control).value = null;
          } else {
            (<StandardComponent>column.Control).value = '';
          }
        }
      });
    });
  }
}
